import React, { useEffect, useState } from 'react'
import styled from'styled-components'

/**
* @author zilahir
* @function ProgressBar
**/

const Bar = styled.span`
	background-color: #694BB0;
	width: ${props => props.width}%;
	height: 100%;
`

const ProgressBar = () => {
	const [interval, setIntervalVal] = useState(null)
	const [counter, setCounter] = useState(0)
	useEffect(() => {
		setTimeout(() => {
			setIntervalVal(setInterval(setCounter(counter + 1), 1000))
		}, 1000)
	}, [counter])
	return (
		<div className="progressbar-container">
			<Bar width={counter * 10} />
		</div>
	 )
}

export default ProgressBar